export default __webpack_public_path__ + "locales/zh-CN/Common.json?hash=c229c51f0562de8b443d06a40b3b9769";